module.exports = __webpack_public_path__ + "static/media/cz.1f1b1130.webp";